
import {  EventStatePayload } from '../../../../../redux/eventSlice';
import DynamicTextTimeInterval from "components/fields/DynamicTimeInterval";
import { RootState } from '../../../../../redux/store';
import { useSelector } from 'react-redux';
import {formatDate } from '../../../../../utils/util';

type CreateEventProps = {
    eventObject?: EventStatePayload;
  };



const NonWorkingTime = ({ eventObject }:CreateEventProps) => {
  const today = new Date();
  const mindate = formatDate(today);
  const event = useSelector((state: RootState) => state.event.payload);
  const newEvent = {
    startTime: event.startTime,
    endTime: event.endTime,
    fromTimeZone: event.timezone,
    date: mindate,
    duration: event.meetingDuration,
    scheduleDays: event.scheduleDays,
  };

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      <div className="mt-4">
      
        <b> Non Working Hours</b>
      </div>
      <DynamicTextTimeInterval newEvent = {newEvent} eventObject={eventObject}/>
    </div>
  );
}

export default NonWorkingTime;